import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import schedulerService from 'services/scheduler.service';

const initialState = {
    scheduler: [],
    performanceSchedulerTableLoading: false,
    errorMessage: null,
    successMessage: null
};

export const getPerformanceScheduler = createAsyncThunk("getPerformanceScheduler/getScheduler", async ( data, {
    rejectWithValue
}) => {
    try {
        return await schedulerService.getSchedulerService(data);
    } catch (error) {
        return rejectWithValue(error);
    }
})

export const formPerformanceScheduler = createAsyncThunk("formPerformanceScheduler/Scheduler", async ( data, {
    rejectWithValue
}) => {
    try {
        return await schedulerService.formPerformanceSchedulerService(data);
    } catch (error) {
        return rejectWithValue(error);
    }
})


export const PerformanceSchedulerSlice = createSlice({
    name: 'PerformanceSchedulerSlice',
    initialState,
    reducers: {
        resetErrorMessages: (state) => {
            state.errorMessage = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getPerformanceScheduler.fulfilled, (state, action) => {
            state.scheduler = action.payload.data.content;
            state.performanceSchedulerTableLoading = false;
        });
        builder.addCase(getPerformanceScheduler.pending, (state, action) => {
            state.performanceSchedulerTableLoading = true;
            state.successMessage = null;
            state.errorMessage = null;
        });
        builder.addCase(getPerformanceScheduler.rejected, (state, action) => {
            state.performanceSchedulerTableLoading = false;
        });
        builder.addCase(formPerformanceScheduler.fulfilled, (state, action) => {
            if(action.payload?.response?.data?.error) {
                state.errorMessage = action.payload?.response?.data?.error;
            } else {
                state.successMessage = 'success';
            }
        });
        builder.addCase(formPerformanceScheduler.pending, (state, action) => {
            state.successMessage = null;
            state.errorMessage = null;
        });
        builder.addCase(formPerformanceScheduler.rejected, (state, action) => {
            state.errorMessage = action.payload?.response?.data?.error;
        });
    }
});

export const {
    resetErrorMessages
} = PerformanceSchedulerSlice.actions;

export default PerformanceSchedulerSlice.reducer;